import { Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { BtnStyleTypes } from 'libraries/ui_button/btn.component';
import { SizeProp } from "@fortawesome/fontawesome-svg-core";
import { faChevronDown, IconDefinition } from "@fortawesome/free-solid-svg-icons";

export interface IPopupMenuConfig {
    buttonLabel: string;
    buttonType?: string;
    items: IMenuItem[];
}

export interface IMenuItem {
    label: string;
    actionName: string;
}

@Component({
    selector: 'popup-menu',
    template: `
        <div class="menu-container">
            <mat-menu #menu='matMenu'>

                    <button #menuItem
                            mat-menu-item
                            *ngFor="let item of menuConfig.items;"
                            type="button"
                            [disabled]="disabled"
                            (mouseenter)="menuItem.focus()"
                            (click)="onSelectEmission(item.actionName)"
                            (keypress.enter)="onSelectEmission(item.actionName)"
                            [class.selected]="item.actionName === selectedActionName">
                    <span class="e2e-menu-item-{{item.actionName}}">
                        {{ item.label }}
                    </span>
                    </button>

            </mat-menu>
            <btnForm *ngIf="disabled"
                     [styleType]="styleType"
                     [buttonClass]="buttonClass"
                     [ngClass]="{'menu-open': isMenuOpen, '': true }"
                     [disabled]="disabled">
                
                <fa-icon *ngIf="iconPosition === 'before'"
                         [size]="iconSize"
                         [class.icon-before]="menuConfig.buttonLabel.length > 0"
                         [icon]="(icon | iconNameToDefinition) || chevronDown"></fa-icon>


                <span *ngIf="menuConfig.buttonLabel.length > 0" [innerHTML]="menuConfig.buttonLabel"></span>
                <fa-icon *ngIf="iconPosition === 'after'"
                         [size]="iconSize"
                         [class.icon-after]="menuConfig.buttonLabel.length > 0"
                         [icon]="(icon | iconNameToDefinition) || chevronDown"></fa-icon>
            </btnForm>
            <btnForm *ngIf="!disabled"
                     [styleType]="styleType"
                     [buttonClass]="buttonClass"
                     [ngClass]="{'menu-open': isMenuOpen, '': true }"
                     [matMenuTriggerFor]="menu"
                     [disabled]="disabled"
                     (menuOpened)="menu.focusFirstItem(); isMenuOpen = true"
                     (menuClosed)="isMenuOpen = false;">
                <fa-icon *ngIf="iconPosition === 'before'"
                         [size]="iconSize"
                         [class.icon-before]="menuConfig.buttonLabel.length > 0"
                         [icon]="(icon | iconNameToDefinition) || chevronDown"></fa-icon>


                <span *ngIf="menuConfig.buttonLabel.length > 0" [innerHTML]="menuConfig.buttonLabel"></span>
                <fa-icon *ngIf="iconPosition === 'after'"
                         [size]="iconSize"
                         [class.icon-after]="menuConfig.buttonLabel.length > 0"
                         [icon]="(icon | iconNameToDefinition) || chevronDown"></fa-icon>

            </btnForm>
        </div>
    `,
    styleUrls: [
        "../../../styles/angular-material/menu.scss",
        "./popup-menu.scss"
    ],
    encapsulation: ViewEncapsulation.None
})

export class PopupMenuComponent {
    @Input()
    public menuConfig: IPopupMenuConfig;

    @Input()
    public icon: string = 'fa-angle-down';

    @Input()
    public selectedActionName: string;

    @Input()
    public buttonClass: string = '';

    @Input()
    public iconPosition: 'before' | 'after' = 'before';

    @Input()
    public styleType: BtnStyleTypes = BtnStyleTypes.actionDo;

    @Input()
    public disabled: boolean = false;

    @Input()
    public iconSize: SizeProp = '1x';

    @Output()
    public readonly onSelect: EventEmitter<string> = new EventEmitter();

    @ViewChild('menu')
    public menu: MatMenu;

    public chevronDown: IconDefinition = faChevronDown;

    public isMenuOpen: boolean = false;

    public onSelectEmission(actionName: string): void {
        this.onSelect.emit(actionName);
    }
}
